import { render, staticRenderFns } from "./RoomEditDialog.vue?vue&type=template&id=09f4bb72&lang=pug&"
import script from "./RoomEditDialog.vue?vue&type=script&lang=js&"
export * from "./RoomEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomEditDialog.vue"
export default component.exports